const SLICE = -2;

export function getDomain(): string {
  return location.hostname
    .split('.')
    .slice(SLICE)
    .join('.');
}
